<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Gallery',

    metaInfo: { title: '4D Labs, Inc.' },

    extends: View,

    mixins: [
      LoadSections([
        'hero',
        'video',
        'social-media',
        // 'test',
        'gallery',
        'newsletter',
        'mobile',
        // 'info-graph',
        'marketing',
        'we-help-your-success',
        'contact-us',
        'theme-features',
        'about-our-product',
        'parallax',
        // 'news',
        'info-alt',
        'map',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'recent-works',
      },
    },
  }
</script>
